import { render } from "./Worklogs.vue?vue&type=template&id=28edc379"
import script from "./Worklogs.vue?vue&type=script&lang=js"
export * from "./Worklogs.vue?vue&type=script&lang=js"

import "./Worklogs.vue?vue&type=style&index=0&id=28edc379&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__